import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ConnectedUserContext } from './connectedUser-context';

import Home from './Home';
import Stats from './stats';
import Players from './players';
/*import PlayersQvneaAll from './playersQvneaAll';*/
import PlayerAdmin from './admin/players/PlayerAdmin';
import QvneaBooks from './admin/customers/QvneaBooks';
import QvneaBooksOperationsCSV from './admin/customers/QvneaBooksOperationsCSV';

import Standings from './standings/Standings';
import TeamRosters from './standings/TeamRosters';
import LiveScoresheets from './scoresheets/LiveScoresheets';
import RateSysForm from './standings/RateSysForm';
import Scoresheet from './scoresheets/Scoresheet';

import TableauDemo from './dashboard/tableauDemo';
import PlayerDashboard from './dashboard/playerDashboard';
import QuebecOpenLeaderboards2018 from './special/QuebecOpenLeaderboards2018';
import QuebecOpenLeaderboards2019 from './special/QuebecOpenLeaderboards2019';
import QuebecOpenLeaderboards2020 from './special/QuebecOpenLeaderboards2020';
import QuebecInvLeaderboards2023 from './special/QuebecInvLeaderboards2023';

// import CreateAccount from './users/CreateAccount';
import Profile from './users/Profile';
import UserAccount from './users/UserAccount';

import MontQvnea from './customers/qvnea/MontQvnea';
import PredatorTour from './customers/qvnea/PredatorTour';

//import Confidentialite from './confidentialite';
import PrivacyPolicy from './PrivacyPolicy';
import Termes from './termes';

import Admin from './admin/Admin';

class Main extends React.Component {

	static contextType = ConnectedUserContext;

  constructor(props) {
		super(props);
	}

	render() {
		// console.log('%cMAIN', "color: red")
		// console.log("this.props", this.props)
		const { connectedUser } = this.context;
		return (
			<div className="main margin-top-main">
				<div className="container-fluid">
 					
					<Routes>

					{/* Main Routes accessibles à tous */}
					<Route path="/" element={<Home />} />
					<Route path="stats" element={<Stats />} />
					<Route path="players" element={ <Players />} />
					<Route path="players/:pIdx" element={	<PlayerAdmin />} />
					{/*	<Route path="/playersQvneaAll" element={ <PlayersQvneaAll />} /> */}
					<Route path="standings/:seasonTag" element={ <Standings /> }/>
					<Route path="teamRosters/:seasonTag" element={ <TeamRosters />} />
					<Route path="rateSysForm/:seasonTag" element={<RateSysForm />} />
					<Route path="scoresheet/:seasonTag/:ssIdx/:mode" element={<Scoresheet />} />

					{/* Specials */}
					<Route path="special/QuebecOpenLeaderboards2018" element={<QuebecOpenLeaderboards2018 />} />
					<Route path="special/QuebecOpenLeaderboards2019" element={<QuebecOpenLeaderboards2019 />} />
					<Route path="special/QuebecOpenLeaderboards2020" element={<QuebecOpenLeaderboards2020 />} />
					<Route path="special/QuebecInvLeaderboards2023" element={<QuebecInvLeaderboards2023 />} />

					{/* QVNEA */}
					<Route path="qvnea/mont-qvnea" element={<MontQvnea />} />
					<Route path="qvnea/predator-tour" element={<PredatorTour />} />

					{/* QVNEA ADMIN */}
					<Route path="qvnea/qvnea-books" element={	<QvneaBooks />} />
					<Route path="qvnea/qvnea-books/csv" element={<QvneaBooksOperationsCSV />} />

					{/* Autres */}
					<Route path="tableau-de-bord" element={<TableauDemo />} />
					<Route path="confidentialite" element={<PrivacyPolicy />} />
					<Route path="termes-et-conditions" element={<Termes />} />

					{/* User */}
					<Route 
						path="/profile" 
						element={ <Profile /*refreshConnectedUser={this.props.refreshConnectedUser}*/	/>} />

					<Route 
						path="userAccount" 
						element={
							<UserAccount connectedUser={connectedUser} />
						} 
					/>

					{/* USER RESTRICTED */}							
					<Route path="playerDashboard" element={ <PlayerDashboard /> } />
	        <Route path="liveScoresheets/:seasonTag" element={<LiveScoresheets />} />

					{/* ADMIN - ADMIN - ADMIN */}
					{/* Routes needing a valid connectedUser */}
					{connectedUser && (
						<Route path="admsafe" 
							element={
								<Admin 
                  refreshConnectedUser={this.props.refreshConnectedUser}
								/>
							} 
						/>
			    )}

				  {/* Route catch-all à la fin */}
				  <Route path="*" element={
				    <div style={{ padding: "2rem" }}>
				      <h2>Page introuvable / accès refusé</h2>
				      <p>La page demandée n'existe pas ou vous n'y avez pas accès.</p>
				    </div>
				  } />

		      </Routes>

				</div>
			</div>
		)
	}
}

export default Main;
